import script from "./Activity_InfoGeneric.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_InfoGeneric.vue?vue&type=script&setup=true&lang=js"

import "./Activity_InfoGeneric.vue?vue&type=style&index=0&id=42c54e6d&lang=less&scoped=true"
import "./Activity_InfoGeneric.vue?vue&type=style&index=1&id=42c54e6d&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c54e6d"]])

export default __exports__